<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择物料"
      width="1200px"
      top="8vh"
  >
    <table-select
        ref="tableSelect"
        :filter="filter"
        :sel-reset="true"
        :columns="columns"
        module="basic"
        url="sapBaseMaterials"
        :is-multi-select="isMultiSelect"
        @select="selectMaterial"
        @on-selection-change="selectHandle"
        @reset="resetHandle"
    > 
      <template v-if="isMultiSelect" slot="adBtns">
        <div style="margin: 5px 0;">
          <el-button type="primary" @click="handleSelectMaterial">选择</el-button>
        </div>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="物料编号" prop="no">
            <el-input v-model="filter.no" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="旧物料编号" prop="no">
            <el-input v-model="filter.mappingMaterialNo" placeholder="请输入旧物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称" prop="name">
            <el-input v-model="filter.name" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="规格型号" prop="specification">
            <el-input v-model="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    props: {
      isMultiSelect: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialogVisible: false,
        filter: {
          no: "",
          name: "",
          mrpType: "",
          status: "",
          priceStatus: "",
          specification:"",
          mappingMaterialNo:"",
        },
        selectedRows: [],
      };
    },
    computed: {
      columns() {
        const baseColumns = [
          {
            title: "物料编号",
            key: "no",
            width: 120,
          },
          {
            title: "旧料号",
            key: "mappingMaterialNo",
            width: 120,
          },
          {
            title: "物料名称",
            key: "name",
            width: 200,
            tooltip: true,
          },
          {
            title: "规格型号",
            key: "zmyxh",
          },
          {
            title: "厂家型号",
            key: "manufacturerModel",
          },
          {
            title: "品名",
            key: "sapProductName",
          },
        ];

        // 如果是多选模式，在最前面添加选择列
        if (this.isMultiSelect) {
          return [
            {
              type: "selection",
              width: 55,
            },
            ...baseColumns,
          ];
        } else {
          return [
            {
              title: "操作",
              slot: "action",
              width: 80,
              align: "center",
              fixed: "left",
            },
            ...baseColumns,
          ];
        }
      },
    },
    methods: {
      open(filter) {
        this.dialogVisible = true;
        if (filter) {
          this.filter.status = filter.status;
          this.filter.priceStatus = filter.priceStatus;
        }
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      // 单选
      selectMaterial(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      selectHandle(selection) {
        this.selectedRows = selection;
      },
      // 多选
      handleSelectMaterial() {
        if (this.selectedRows.length === 0) {
          this.$message.warning("请选择物料");
          return;
        }
        this.dialogVisible = false;
        this.$emit("select-change", this.selectedRows);
      },

      // 重置特殊处理
      resetHandle() {
        this.filter.no = "";
        this.filter.name = "";
        this.$refs.tableSelect.loadData();
      },
    },
  };
</script>
